import {API} from "aws-amplify";
import {getInputContext} from "../utils/api-utils";
import {CASE_MANAGEMENT_SERVICE_API, UPDATE_CASE_STATUS} from "../constants/api-paths";

export async function updateCaseStatus(useCaseName, caseId, status, updateMessage, falsePositiveReason) {
    const request = {
        useCaseName: useCaseName,
        caseId: caseId,
        clientId: "ComplianceDashboard",
        status: status,
        updateMessage: updateMessage,
        falsePositiveReason: falsePositiveReason,
    };

    const input = await getInputContext();
    input.body.requestType = "UpdateCaseStatus";
    input.body.requestString = JSON.stringify(request);
    console.log("Input for updateCaseStatus = " + JSON.stringify(request));

    const resp = await API.post(CASE_MANAGEMENT_SERVICE_API, UPDATE_CASE_STATUS, input);
    console.log(UPDATE_CASE_STATUS + " API was called, response : " + JSON.stringify(resp));

    if (resp.statusCode !== "200") {
        console.log("Error in updating case status for caseId: " + caseId + ", response: " + JSON.stringify(resp));
    }
}
